import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { useGatewayManufacturedDevices } from "../../../../hooks/useGatewayManufacturedDevices"
import { digitalManagerApi } from "../../../../services/api"
import { GatewayManufacturedDeviceGeneralInfo } from "../../../models/Gateway"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function GatewaysManufacturedDevices() {
  const {
    manufacturedDevicesList,
    isLoadingManufacturedDevice,
    reloadManufacturedDevices,
  } = useGatewayManufacturedDevices()
  const navigate = useNavigate()

  const onValidate = useCallback(
    (row: EntityRow) => {
      digitalManagerApi
        .put(`/gateway/resetPassword?manufacturedDeviceId=${row.id}`)
        .then(() => {
          toast.success("Reset password request validated successfully")
          reloadManufacturedDevices()
        })
        .catch(() => {
          toast.error("Failed to validate the request")
        })
    },
    [reloadManufacturedDevices]
  )

  const onDetails = useCallback(
    (row: EntityRow) => {
      navigate(`/gateway/manufacturedDevices/${row.id}`)
    },
    [navigate]
  )

  const cols = [
    { field: "serialNumber", headerName: "Serial Number" },
    { field: "macAddressEth0", headerName: "Mac Address Eth0" },
    { field: "macAddressEth1", headerName: "Mac Address Eth1" },
    { field: "macAddressWlan0", headerName: "Mac Address Wlan0" },
  ]

  const rows = manufacturedDevicesList.map((d: GatewayManufacturedDeviceGeneralInfo) => ({
    id: d.id,
    serialNumber: d.serialNumber,
    macAddressEth0: d.macAddressEth0 ?? "",
    macAddressEth1: d.macAddressEth1 ?? "",
    macAddressWlan0: d.macAddressWlan0 ?? "",
    canValidate: d.gatewayResetPasswordRequests.some((rpr) => rpr.completionDate == null),
  }))

  const handleActionMenuClick = useCallback(
    (item: { title: string; iconName?: string }, row: EntityRow) => {
      if (item.title === "Details") {
        onDetails(row)
      }
      if (item.title === "Validate") {
        if (!row.canValidate) {
          toast.info("No pending reset password requests to validate")
          return
        }
        onValidate(row)
      }
    },
    [onDetails, onValidate]
  )

  return (
    <EntityTab
      rows={rows}
      cols={cols}
      isLoading={isLoadingManufacturedDevice}
      actionItems={[
        { title: "Details", iconName: "icon_abb_dias icon-abb_system-detailsy" },
        { title: "Validate", iconName: "icon_abb_dias icon-abb_Task-List-Check-2" },
      ]}
      onActionMenuClick={handleActionMenuClick}
    />
  )
}
